import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './style.scss';

const SLIDESHOW_INTERVAL_MS = 2500;

function LaptopScreenModal({ show, onClose, title, content, image, images, linkButtons }) {
  const [slideIndex, setSlideIndex] = useState(0);
  const imageList = images && images.length > 0 ? images : null;
  const singleImage = !imageList && image ? image : null;

  useEffect(() => {
    if (!show || !imageList || imageList.length <= 1) return;
    const timer = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % imageList.length);
    }, SLIDESHOW_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [show, imageList]);

  useEffect(() => {
    if (show && imageList) setSlideIndex(0);
  }, [show, imageList]);

  const currentSrc = imageList
    ? (typeof imageList[slideIndex] === 'string'
        ? imageList[slideIndex]
        : imageList[slideIndex]?.default ?? imageList[slideIndex])
    : singleImage
    ? typeof singleImage === 'string'
      ? singleImage
      : singleImage?.default ?? singleImage
    : null;

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="laptop-screen-modal"
      dialogClassName="laptop-screen-modal__dialog"
      contentClassName="laptop-screen-modal__content"
    >
      <div className="laptop-screen-modal__wrap">
        <button
          type="button"
          className="laptop-screen-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="laptop-screen-modal__laptop">
          <div className="laptop-screen-modal__screen laptop-screen-modal__screen--no-frame">
            {title && (
              <h3 className="laptop-screen-modal__screen-title">{title}</h3>
            )}
            {currentSrc && (
              <div className="laptop-screen-modal__screen-image-wrap">
                <img
                  key={imageList ? slideIndex : 'single'}
                  src={currentSrc}
                  alt=""
                  className="laptop-screen-modal__screen-image laptop-screen-modal__screen-image--fade"
                />
              </div>
            )}
            {linkButtons && linkButtons.length > 0 && (
              <div className="laptop-screen-modal__link-buttons-wrap">
                <div className="laptop-screen-modal__link-buttons">
                  {linkButtons.map((btn, i) => (
                    <a
                      key={i}
                      href={btn.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="laptop-modal-link-btn"
                    >
                      {btn.label}
                    </a>
                  ))}
                </div>
              </div>
            )}
            {content && (
              <div className="laptop-screen-modal__screen-text" dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LaptopScreenModal;
